import { put, call, takeLatest } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as authenticationService from '../../services/authenticationService';
import { SONNET_AUTH_ORIGIN } from '../../config';
import { getUserPreferredLang } from '../../utils/common/appLanguage/appLanguage';
import { getCookie, cookies } from '../../utils/common/cookies';

function* validateLoggedIn() {
  try {
    const response = yield call(authenticationService.validateLoggedIn);
    if (response.errors) {
      yield put(actions.validateLoggedInFailed(response.errors));
    } else {
      // set sonnetAddressBookUid from shared cookie : abuid
      response.data.checkSession.sonnetAddressBookUid = decodeURIComponent(getCookie(cookies.sonnetAddressBookUId));
      // set preferredLang from shared cookie : CMSPreferredCulture
      response.data.checkSession.preferredLang = getUserPreferredLang();
      yield put(actions.validateLoggedInSuccess(response.data.checkSession));
    }
  } catch (error) {
    yield put(actions.validateLoggedInFailed(error));
  }
}

function* logout() {
  try {
    const response = yield call(authenticationService.logout);
    if (response.errors) {
      yield put(actions.logoutFailed(response.errors));
    } else if (response.data.logout.isLoggedIn === false) {
      yield put(actions.logoutSuccess());
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace(`${SONNET_AUTH_ORIGIN}/login`);
    }
  } catch (error) {
    yield put(actions.logoutFailed(error));
  }
}

export default function* saga() {
  yield takeLatest(actionTypes.VALIDATE_LOGGEDIN, validateLoggedIn);
  yield takeLatest(actionTypes.LOGOUT, logout);
}
